import '@widesk-ui/components/styles/Tag.scss';

import AntdTag from 'antd/lib/tag';
import React   from 'react';
import { isReadable } from '@widesk-core/tools/colors';
import { hexToRgbA } from '@widesk-core/tools/colors';
import useTheme from '@widesk-ui/hooks/useTheme';
import { isHexColor } from '@widesk-core/tools/colors';

export type TagProps = {
	color?: string;
	bordered?: boolean;
	icon?: React.ReactNode;
	style?: React.CSSProperties;
	enableAutoTextColor?: boolean;
} & React.PropsWithChildren;

export default function Tag(props: TagProps) {
	const { color, enableAutoTextColor } = props;
	const theme = useTheme();

	let textInBlack = false;
	if (color && enableAutoTextColor && isHexColor(color)) {
		textInBlack = !isReadable(hexToRgbA("#FFF"), hexToRgbA(color));
	}

	return (
		<AntdTag
			className="widesk-tag"
			color={props.color}
			bordered={props.bordered}
			icon={props.icon}
			style={{
				...(textInBlack ? { color: theme.colorTextBase } : undefined),
				...props.style,
			}}
		>
			{props.children}
		</AntdTag>
	);
}
